import React from 'react'
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import TopHeader from 'components/TopHeader'
import VentasPorRango from './VentasPorRango'
import ProductosMasVendidos from './ProductosMasVendidos'
import CategoriasMasVendidas from './CategoriasMasVendidas'
import './reportes.css'

const Reportes = () => {
	const { path } = useRouteMatch()

	return (
		<Container fluid className="reportes-container">
			<Switch>
				<Route exact path={path}>
					<Redirect to={`${path}/ventas`} />
				</Route>
				<Route path={`${path}/ventas`}>
					<TopHeader iconName="chart-line" text="Reportes - Ventas por rango" />
					<VentasPorRango />
				</Route>
				<Route path={`${path}/productos`}>
					<TopHeader iconName="box" text="Reportes - Productos más vendidos" />
					<ProductosMasVendidos />
				</Route>
				<Route path={`${path}/categorias`}>
					<TopHeader iconName="tags" text="Reportes - Categorías más vendidas" />
					<CategoriasMasVendidas />
				</Route>
			</Switch>
		</Container>
	)
}

export default Reportes
